import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import axios from 'axios';
import invariant from '../utils/invariant';
/**
 * @param {?object} config
 * @param {?object} interceptors
 * @returns {Axios}
 */

export function createInstance(config, interceptors) {
  var instance = axios.create(config);

  if (interceptors) {
    var request = interceptors.request,
        response = interceptors.response;

    if (request) {
      var _instance$interceptor;

      invariant(Array.isArray(request) && request.every(function (x) {
        return typeof x === 'function';
      }), 'interceptors.request expected a array of function, instead received %s.', request);

      (_instance$interceptor = instance.interceptors.request).use.apply(_instance$interceptor, _toConsumableArray(request));
    }

    if (response) {
      var _instance$interceptor2;

      invariant(Array.isArray(response) && response.every(function (x) {
        return typeof x === 'function';
      }), 'interceptors.response expected a array of function, instead received %s.', response);

      (_instance$interceptor2 = instance.interceptors.response).use.apply(_instance$interceptor2, _toConsumableArray(response));
    }
  }

  return instance;
}

var Client =
/*#__PURE__*/
function () {
  _createClass(Client, null, [{
    key: "clone",

    /**
     * @static
     * @param {Client} client
     * @returns {Client}
     */
    value: function clone(client) {
      invariant(client instanceof Client, 'client expected a instance of Client, instead received %s.', client);
      return client.clone();
    }
    /**
     * @constructor
     * @param {?object} config
     * @param {?object} interceptors
     * @returns {Client}
     */

  }]);

  function Client(config, interceptors) {
    _classCallCheck(this, Client);

    this._config = config;
    this._interceptors = interceptors;
  }
  /**
   * @public
   * @returns {Client}
   */


  _createClass(Client, [{
    key: "clone",
    value: function clone() {
      return new Client(this._config, this._interceptors);
    }
    /**
     * @public
     * @param {?object} config
     * @returns {Client}
     */

  }, {
    key: "setConfig",
    value: function setConfig(config) {
      this._config = config;

      if (this._instance) {
        this._instance = createInstance(config, this._interceptors);
      }

      return this;
    }
    /**
     * @public
     * @param {?object} interceptors
     * @returns {Client}
     */

  }, {
    key: "setInterceptors",
    value: function setInterceptors(interceptors) {
      this._interceptors = interceptors;

      if (this._instance) {
        this._instance = createInstance(this._config, interceptors);
      }

      return this;
    }
    /**
     * @public
     * @param {?object} config
     * @returns {Client}
     */

  }, {
    key: "updateConfig",
    value: function updateConfig(config) {
      return this.setConfig(_objectSpread({}, this.getConfig(), config));
    }
    /**
     * @public
     * @returns {?object}
     */

  }, {
    key: "getConfig",
    value: function getConfig() {
      return this._config;
    }
    /**
     * @public
     * @returns {?object}
     */

  }, {
    key: "getInterceptors",
    value: function getInterceptors() {
      return this._interceptors;
    }
    /**
     * @public
     * @returns {Axios}
     */

  }, {
    key: "getInstance",
    value: function getInstance() {
      if (!this._instance) {
        this._instance = createInstance(this._config, this._interceptors);
      }

      return this._instance;
    }
    /**
     * @public
     * @param {?object} auth
     * @returns {Client}
     */

  }, {
    key: "authorize",
    value: function authorize(auth) {
      invariant(auth && typeof auth.authorize === 'function', 'auth expected a object has authorize method function, instead received %s.', auth);
      auth.authorize(this);
      return this;
    }
    /**
     * @public
     * @returns {Axios}
     */

  }, {
    key: "request",
    get: function get() {
      return this.getInstance();
    }
  }]);

  return Client;
}();

export default Client;